import React, { useEffect, useState } from "react";
import { Tab, Nav, Form } from "react-bootstrap";
import Pagination from "react-bootstrap/Pagination";
import { Link } from "react-router-dom";
import clientimg from "../asset/images/onboarding-pending/client-img.jpg";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Header from "../Components/Header";
import Sidebar from "../Components/Sidebar";
import axios from "axios";
import OnboardingPendingCard from "../Pages/Onboarding/OnboardingPendingCard";
import OnboardingPendingSearch from "./OnboardingPendingSearch";
// import { set } from "react-hook-form";
import { Client_Search } from "../Configuration/API_URL";
import Filter from "../Pages/Onboarding/Filter";
import SingleSignOnSideBar from "./SingleSignOnSideBar";
import { AESEncryption, ApiResDecrypt } from "../CommonMethhods/CommonMethods";

function OnboardingSearchCard() {
  const storeToken = localStorage.getItem("ssoToken");
  const [linecard, setLinecard] = useState(
    "block-active col-xl-3 col-md-4 col-sm-6 col-12"
  );
  const [show, setShow] = useState(false);
  const [localSearch, setLocalSearch] = useState();
  const [loader, setLoader] = useState(true);

  const [handleSearch, setHandleSearch] = useState(false);
  const [searchDetail, setsearchDetail] = useState(false);
  // const [searchVal, setSearchVal] = useState(
  //   localStorage.getItem("clientSearch")
  // );
  const [value, setValue] = useState();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  function handleGridView(e) {
    if (linecard === "")
      setLinecard("block-active col-xl-3 col-md-4 col-sm-6 col-12");
  }

  function handleListView() {
    if (linecard === "block-active col-xl-3 col-md-4 col-sm-6 col-12")
      setLinecard("");
  }

  function handleSearchClick(value) {
    setHandleSearch(value);
  }

  const searchCardDetail = async (searchVal) => {
    let payloadValue = {
      keyword: searchVal,
      Status: "",
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getSearchDetail = await axios.post(
        Client_Search.Search_URL,

        {},
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const response = ApiResDecrypt(getSearchDetail?.data);

      const res = response.data.clients;

      if (res.length === 0) {
        setsearchDetail(false);
      } else {
        setsearchDetail(res);
      }

      setLoader(false);
    } catch (error) {
      setLoader(false);
    }
  };

  function handleLocalSearch(e) {
    setValue(e.target.value);
  }

  function checkValidate(e) {
    e.preventDefault();
    if (value.length >= 3) {
      searchCardDetail(value);
    }
  }

  useEffect(() => {
    if (handleSearch) {
      searchCardDetail(localStorage.getItem("clientSearch"));
      setHandleSearch(false);
    }
  }, [handleSearch]);

  useEffect(() => {
    searchCardDetail(localStorage.getItem("clientSearch"));
  }, []);

  function updateStatus(res) {
    setsearchDetail(res);
  }

  return (
    <>
      <Header
        handleSearchClick={handleSearchClick}
        handleSearch={handleSearch}
      />
      <SingleSignOnSideBar />
      <main id="main-content" className="onboarding-pending">
        <Tab.Container id="left-tabs-example" defaultActiveKey="pending">
          {/* page search and filters start ,menu */}
          <div className="onboarding-secondary-tab-list">
            <div className="search-box">
              <form onSubmit={checkValidate} method="post" action="">
                <div className="form-group">
                  <input
                    type="text"
                    name="search-text"
                    className="input-st"
                    placeholder="Enter atleast 3 characters"
                    autoComplete="off"
                    onChange={handleLocalSearch}
                  />
                  <input
                    type="submit"
                    name="submit"
                    value="submit"
                    className="submit-btn"
                  />
                </div>
              </form>
            </div>
            <div className="menu-rank-wrapper">
              <div className="menu-wrapper">
                <span
                  className="icon-block-menu"
                  onClick={handleGridView}
                ></span>
                <span
                  className="icon-horizontal-menu"
                  onClick={handleListView}
                ></span>
              </div>
              <div className="filter-btn-wrapper">
                <Filter updateStatus={updateStatus} tabStatus={"Onboarded"} />
              </div>
            </div>
          </div>

          <OnboardingPendingSearch
            // handleSearch={handleSearch}
            // handleSearchClick={handleSearchClick}
            linecard={linecard}
            searchDetail={searchDetail}
            loader={loader}
          />
        </Tab.Container>
      </main>
    </>
  );
}

export default OnboardingSearchCard;
